import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "lodash";
import { DialogBox, DialogBoxFooterType, NoLink, SelectInput, ZeroToInfiniteGrid } from "~/core";
import TableCell from "~/core/components/tables/data-table/components/table-cell";
import { withEditableGrid } from "~/hocs";
import { model } from "./../data";
import {
    getAgBytesErrorClassNames,
    mapToPicklistValue,
    prepareSelectableOptions,
} from "~/admin/utils";
import { messages } from "~/admin/agBytes/i18n-messages";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";
import { messages as globalMessages } from "~/i18n-messages";
import { GUID, ID, NAME, VALUE } from "~/admin/data";
import { IS_SELECTABLE } from "~/admin/setup/customer/use-product-list";

import "./product-list.css";

const PROPS_PRODUCT_NAME = "name";

class ProductList extends Component {
    static propTypes = {
        apiErrors: PropTypes.any,
        record: PropTypes.array,
        formatMessage: PropTypes.func,
        toggleModal: PropTypes.func,
        renderDeleteModal: PropTypes.func,
        onChange: PropTypes.func,
        options: PropTypes.array,
        onAdd: PropTypes.func,
        onEdit: PropTypes.func,
        onDelete: PropTypes.func,
        onAddOrEditItem: PropTypes.func,
        deleteItem: PropTypes.func,
        isEditing: PropTypes.bool,
        isDeleting: PropTypes.bool,
        editData: PropTypes.object,
        unlinkedProductGuids: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            editOptions: [],
            editingItem: false,
            records: [],
            lastRecord: null,
            lastOptions: null,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { record, options } = nextProps;
        if (record === prevState.lastRecord && options === prevState.lastOptions) {
            return null;
        }
        const records = (record || []).map((recordItem) => {
            const selectedProduct = (options || []).find(
                (product) => product.guid === recordItem[model.PROPS_PRODUCT_GUID]
            );
            return {
                ...recordItem,
                [NAME]: (selectedProduct && selectedProduct[NAME]) || recordItem.productName,
            };
        });
        return {
            records,
            lastRecord: record,
            lastOptions: options,
        };
    }

    initializeProducts = (options) => {
        this.setState({
            editOptions: prepareSelectableOptions(options, {
                guid: GUID,
                label: NAME,
                id: ID,
            }),
        });
    };

    onEdit = (record, index) => {
        this.initializeProducts(this.props.options);
        this.setState({ editingItem: true });
        const keysToUpdate = [
            {
                name: [model.PROPS_PRODUCT_GUID],
                key: GUID,
            },
            {
                name: [NAME],
                key: VALUE,
            },
        ];
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.initializeProducts(this.props.options);
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, toggleModal } = this.props;
        return (
            <DialogBox
                action="save"
                actionDisabled={!editData[model.PROPS_PRODUCT_GUID]}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                forceOverflow
                isOpen={isEditing}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.product
                )}
            >
                <SelectInput
                    required
                    tabIndex={0}
                    autoFocus
                    optionIsHiddenKey={IS_SELECTABLE}
                    openOnFocus={false}
                    options={this.state.editOptions}
                    placeholderText={formatMessage(messages.productName)}
                    value={mapToPicklistValue({
                        options: this.state.editOptions,
                        selectedGuid: editData[model.PROPS_PRODUCT_GUID],
                    })}
                    containerClassNames={["product-list-dropdown"]}
                    onChange={(value) => {
                        this.props.onChange({
                            [model.PROPS_PRODUCT_GUID]: value == null ? "" : value.guid,
                            [NAME]: value == null ? "" : value.name,
                        });
                    }}
                />
            </DialogBox>
        );
    };

    renderProductNameCell = (value, record) => {
        const { formatMessage, unlinkedProductGuids } = this.props;
        const isUnlinked = Boolean(
            unlinkedProductGuids && unlinkedProductGuids.has(record[model.PROPS_PRODUCT_GUID])
        );
        const title = isUnlinked
            ? `${value} \n ${formatMessage(globalMessages.productNotLinkedInAgvance)}`
            : `${value}`;
        return (
            <TableCell
                key={`row-${PROPS_PRODUCT_NAME}`}
                className={classnames({ "unlinked-product": isUnlinked })}
                title={title}
            >
                <p>{value}</p>
            </TableCell>
        );
    };

    render() {
        const { formatMessage } = this.props;
        const { records } = this.state;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {records && records.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={records}
                        columns={{
                            [PROPS_PRODUCT_NAME]: {
                                title: formatMessage(messages.name),
                                printer: this.props.unlinkedProductGuids
                                    ? this.renderProductNameCell
                                    : undefined,
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {this.props.renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        classNames={getAgBytesErrorClassNames(15, this.props.apiErrors, [
                            "add-link",
                        ])}
                        label={createAddLinkLabelText(formatMessage, messages.product)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(ProductList);
